import { render, staticRenderFns } from "./CreditClasses.vue?vue&type=template&id=5baf53a0"
import script from "./CreditClasses.vue?vue&type=script&lang=js"
export * from "./CreditClasses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports